import { ReportLine } from "../TripReport/TripReport";
import { DateConstants } from "../../utilities/WeekSchedule/DateConstants";
import { Trip } from "../Trip/Trip";
import { Schedule } from "../../utilities/Scheduling/Schedule";
import { RunConfig } from "../RunConfiguration/RunConfig";
import { ReportDay } from "./ReportDay";
import { ReportHour } from "./ReportHour";
import * as moment from "moment";

export class Report {
    _id: any;
    dateGenerated: Date;
    reportName: String;
    startDate: Date;
    runConfig: RunConfig;
    endDate: Date;
    companyid: Number;
    locationid: Number;
    company: String;
    location: String;
    weekid: number;
    days: Array<ReportDays>;
    schedule: Array<Schedule> = new Array<Schedule>();

    createReportLines(): Array<ReportLine> {

        var lines = new Array<ReportLine>();

        this.days.forEach(d => {

            d.trips.forEach(t => {
                lines = lines.concat(t.getTripReportDetails());
            });
        });

        return lines;
    }

    static buildWeekFormat(start:moment.Moment,end:moment.Moment,trips:Array<Trip>){

        let days:Array<ReportDay> = [];

        //build the days
        while(start.isSameOrBefore(end)){
            days.push(new ReportDay(start.format(DateConstants.standardDateFormat),[]));
            start.add(1,"d")
        }
        days.forEach(d =>{
            start = moment(d.date)
            end = start.clone().add(1,"d");
            while(start.isBefore(end)){
                var tripsForHour = trips.filter(x => moment(x.slotTime).toDate().toLocaleString() == start.toLocaleString());
                d.hours.push(new ReportHour(start.toLocaleString(),tripsForHour))
                start.add(1,"h");
             }
        });
        //this.getTheBug(days);
        return days;
    }

    static getTheBug(items:Array<any>){
    
        var bad = [];
        var good = [];
        items.forEach(t =>{
            try{
                JSON.stringify(t);
                good.push(t);
            }catch(e){
                bad.push(t);
            }            
        });
        return bad;
    }

    static formatReportDays(days:Array<ReportDays>) {

        let newDays: Array<ReportDay> = [];

        days.forEach(d => {
            var newDay = new ReportDay(d.date, []);
            newDays.push(newDay);
            let hours: Map<string, Array<Trip>> = new Map<string, Array<Trip>>();
            d.trips.forEach(t => {
                var arr = hours.get(moment(t.slotTime).toDate().toString())
                if (arr) {
                    arr.push(t);
                } else {
                    hours.set(moment(t.slotTime).toDate().toString(), [t]);
                }
            });
            hours.forEach((value: Array<Trip>, key: string) => {
                newDay.hours.push(new ReportHour(key, value));
            });
        });
        return newDays;
    }

    static unravel(report:any){
        let days : Array<{date:string,trips:Array<Trip>}>= [];
        report.days.forEach(d =>{
            var day = {
                date:d.date,
                trips:[]
            }
            d.hours.forEach(h =>{
                day.trips = day.trips.concat(h.trips);
            })
            days.push(day);
        });
        report.days = days;
        return report;
    }

}

export class ReportDays {
    date: string;
    trips: Array<Trip>
}